// extracted by mini-css-extract-plugin
export default {"row":"ingredients-row_row__Ml3AW","list":"ingredients-row_list__Mpb8T"};